import { Injectable } from '@angular/core';

import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  getForgetPwdToken(): string {
    let _token = this.localStorageService.getItem('forgetPwdToken');
    return (_token) ? _token : '';
  }

  // clear cached profile fields (the session itself lives in an HttpOnly cookie, not localStorage)
  destroyToken() {
    this.localStorageService.removeItem('id');
    this.localStorageService.removeItem('username');
    this.localStorageService.removeItem('email');
    this.localStorageService.removeItem('user_role');
    this.localStorageService.removeItem('temp_user');
    this.localStorageService.removeItem('status');
    this.localStorageService.removeItem('reset_at');
    this.localStorageService.logoutUser();  // Please don't delete it.
  }
}

